import { Component, OnInit, Input, Renderer2, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CargosSetFatores } from './cargos-set-fatores';
import { NewPerfil } from 'app/model/newPerfil';

@Component({
  selector: 'app-cargos-set-fatores',
  templateUrl: './cargos-set-fatores.component.html',
  styleUrls: ['./cargos-set-fatores.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CargosSetFatoresComponent implements OnInit {

  @Input() fatores: CargosSetFatores;
  @Input() nomeCiencia: string;
  @Output() setReset = new EventEmitter();
  @Output() fatoresSelecionados = new EventEmitter();
  @Output() carregaPerfisSalvos = new EventEmitter();
  @Output() salvaFiltro = new EventEmitter();
  @ViewChild('div') div: ElementRef;

  perfilIdeal: number;
  perfilMinimo: number;
  perfilMaximo: number;
  conceitoDom: string;
  conceitoInf: string;
  conceitoEst: string;
  conceitoCaut: string;
  noCheck: boolean;

  private upReset: boolean;
  private upPerfisSalvos: NewPerfil[];

  constructor(private renderer: Renderer2) { }

  get reset(): boolean {
    return this.upReset;
  }
  @Input()
  set reset(reset: boolean) {
    this.upReset = reset;
    if (reset === true) {
      this.resetForm();
    } else {
      reset = false;
    }
  }

  get perfisSalvos(): NewPerfil[] {
    return this.upPerfisSalvos;
  }
  @Input()
  set perfisSalvos(perfisSalvos: NewPerfil[]) {
    this.upPerfisSalvos = perfisSalvos;
    if (perfisSalvos.length > 0) {
      this.getPerfisSalvos();
    }
  }

  ngOnInit() {

    if (this.fatores.nome === null) {
      this.addElement();
      this.noCheck = true;
      this.fatores.selected = true;
    } else { this.noCheck = false; }

  }

  getPerfisSalvos() {

    if (this.perfisSalvos) {

      this.perfisSalvos.forEach(perfil => {
        if (this.fatores.nome === perfil.fator) {
          this.fatores.nome = perfil.fator;
          this.fatores.minimo = perfil.minimo;
          this.fatores.ideal = perfil.ideal;
          this.fatores.maximo = perfil.maximo;
          this.fatores.selected = true;

          this.perfilIdeal = perfil.ideal;
          this.perfilMinimo = perfil.minimo;
          this.perfilMaximo = perfil.maximo;

          this.carregaPerfisSalvos.emit();

        }
      });

    }
  }

  addElement() {
    const E: HTMLParagraphElement = this.renderer.createElement('span');
    E.innerHTML = '<div style="color: #fff">Defina o Padrão para o Mínimo, Ideal e Máximo.</div>';
    this.renderer.appendChild(this.div.nativeElement, E);
  }

  onChangeFatores(event: any) {
    this.fatores.selected = event.target.checked;
    this.fatores.nome = event.target.value;
    this.fatoresSelecionados.emit();
    this.salvaFiltro.emit();
  }

  onChangeMin(event: any) {
    this.fatores.minimo = event.target.value ? Number(event.target.value) : undefined;

    // Marcar o checkbox se um valor válido for selecionado
    if (this.fatores.minimo !== undefined && this.fatores.minimo !== 0) {
      this.fatores.selected = true;
    } else {
      this.fatores.selected = false;
    }

    this.fatoresSelecionados.emit();
    this.salvaFiltro.emit();
  }

  onChangeIdeal(event: any) {
    this.fatores.ideal = event.target.value ? Number(event.target.value) : undefined;

    // Marcar o checkbox se um valor válido for selecionado
    if (this.fatores.ideal !== undefined && this.fatores.ideal !== 0) {
      this.fatores.selected = true;
    } else {
      this.fatores.selected = false;
    }

    this.fatoresSelecionados.emit();
    this.salvaFiltro.emit();
  }

  onChangeMax(event: any) {
    this.fatores.maximo = event.target.value ? Number(event.target.value) : undefined;

    // Marcar o checkbox se um valor válido for selecionado
    if (this.fatores.maximo !== undefined && this.fatores.maximo !== 0) {
      this.fatores.selected = true;
    } else {
      this.fatores.selected = false;
    }

    this.fatoresSelecionados.emit();
    this.salvaFiltro.emit();
  }

  resetForm(): void {
    this.fatores.selected = false;
    this.perfilIdeal = 0;
    this.perfilMinimo = 0;
    this.perfilMaximo = 0;
    this.updateReset();
  }

  updateReset() {
    setTimeout(() => {
      this.setReset.emit(false);
    }, 1000);
  }

}
